import React from 'react';
import { Icon } from 'semantic-ui-react';

import { PropertyWalletItemDTO } from '../../../services/properties';
import { ProcessBadge, ProcessBadgesRow } from '../styles';
import {
  PROCESS_ICON_CONFIG,
  processEventIconStyle
} from '../utils/propertyHistoricFormatters';

type Props = {
  activeProcesses?: PropertyWalletItemDTO['activeProcesses'];
};

const PropertyProcessBadges: React.FC<Props> = ({ activeProcesses }) => {
  const badges = PROCESS_ICON_CONFIG.filter(
    config => (activeProcesses?.[config.key] || 0) > 0
  );

  if (!badges.length) {
    return null;
  }

  return (
    <ProcessBadgesRow>
      {badges.map(config => (
        <ProcessBadge key={config.key}>
          <Icon name={config.icon} style={processEventIconStyle} />
          {config.label.replace(/ ativo$/i, '')}
          {activeProcesses?.[config.key] ? ` (${activeProcesses[config.key]})` : ''}
        </ProcessBadge>
      ))}
    </ProcessBadgesRow>
  );
};

export default PropertyProcessBadges;
